import { render } from "./ShotImage.vue?vue&type=template&id=935a80aa&scoped=true"
import script from "./ShotImage.vue?vue&type=script&lang=js"
export * from "./ShotImage.vue?vue&type=script&lang=js"

import "./ShotImage.vue?vue&type=style&index=0&id=935a80aa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935a80aa"]])

export default __exports__